import { Card } from "primereact/card";
import React from "react";

const TermsOfUse = () => {
  return (
    <Card>
      <h1>Conditions générales d’utilisation</h1>
      <div style={{textAlign:"justify",lineHeight:"1.6"}}>
        <br />
        <br />
        <b>ARTICLE 1 : Objet</b>
        <br />
        <br />
        Les présentes « conditions générales d'utilisation » ont pour objet
        l'encadrement juridique de l’utilisation du site servicetransports.com,
        de ses sous-domaines et de ses services. Ce contrat est conclu entre :
        Le gérant du site internet, ci-après désigné « l’Éditeur », Toute
        personne physique ou morale souhaitant accéder au site et à ses
        services, ci-après appelé « l’Utilisateur ». Les conditions générales
        d'utilisation doivent être acceptées par tout Utilisateur, et son accès
        au site vaut acceptation de ces conditions.
        <br />
        <br />
        <b>ARTICLE 2 : Mentions</b>
        <br />
        <br />
        légales Le site servicetransports.com, ses sous-domaines et ses services
        sont édités par la société CITYLOG, SARL, au capital de 200 800€, dont
        le siège social est situé au 5 Rue des Armoiries 94500 Champigny sur
        Marne. La société est représentée par Rached Meftah.
        <br />
        <br />
        <b>ARTICLE 3 : accès aux services</b>
        <br />
        <br />
        L’Utilisateur du site servicetransports.com et de ses sous-domaines a
        accès aux services suivants : Formulaire de contact Login au compte
        Utilisateur Accès au manager du système PTI / DATI Tout Utilisateur
        ayant accès à internet peut accéder gratuitement et depuis n’importe où
        au site. Les frais supportés par l’Utilisateur pour y accéder (connexion
        internet, matériel informatique, etc.) ne sont pas à la charge de
        l’Éditeur. Les services suivants ne sont accessibles pour l’Utilisateur
        que s’il est membre du site (c’est-à-dire qu’il est identifié à l’aide
        de ses identifiants de connexion) : Login au compte Utilisateur Accès au
        manager du système PTI / DATI L’accès au site vitrine
        servicetransports.com et à ses sous-domaines peut être interrompus ou
        suspendus par l’Éditeur, notamment à l’occasion d’une maintenance, sans
        obligation de préavis ou de justification.
        <br />
        <br />
        <b>ARTICLE 4 : Responsabilité de l’Utilisateur</b>
        <br />
        <br />
        L'Utilisateur est responsable des risques liés à l’utilisation de son
        identifiant de connexion et de son mot de passe. Le mot de passe de
        l’Utilisateur doit rester secret. En cas de divulgation de mot de passe,
        l’Éditeur décline toute responsabilité. L’Utilisateur assume l’entière
        responsabilité de l’utilisation qu’il fait des informations et contenus
        présents sur le site servicetransports.com et de ses sous-domaines. Tout
        usage du service par l'Utilisateur ayant directement ou indirectement
        pour conséquence des dommages doit faire l'objet d'une indemnisation au
        profit du site.
        <br />
        <br />
        <b>ARTICLE 5 : Responsabilité de l’Éditeur</b>
        <br />
        <br />
        Tout dysfonctionnement du serveur ou du réseau ne peut engager la
        responsabilité de l’Éditeur. De même, la responsabilité du site ne peut
        être engagée en cas de force majeure ou du fait imprévisible et
        insurmontable d'un tiers. Le site servicetransports.com et ses
        sous-domaines s'engagent à mettre en œuvre tous les moyens nécessaires
        pour garantir la sécurité et la confidentialité des données. Toutefois,
        il n’apporte pas une garantie de sécurité totale. L’Éditeur se réserve
        la faculté d’une non-garantie de la fiabilité des sources, bien que les
        informations diffusées sur le site soient réputées fiables.
        <br />
        <br />
        <b>ARTICLE 6 :Propriété intellectuelle</b>
        <br />
        <br />
        Les contenus du site servicetransports.com et de ses sous-domaines
        (logos, textes, éléments graphiques, vidéos, etc.) sont protégés par le
        droit d’auteur, en vertu du Code de la propriété intellectuelle.
        L’Utilisateur devra obtenir l’autorisation de l’Editeur du site avant
        toute reproduction, copie ou publication de ces différents contenus.
        <br />
        <br />
        <b>ARTICLE 7 : Données personnelles</b>
        <br />
        <br />
        L’Utilisateur doit obligatoirement fournir des informations personnelles
        pour procéder à son inscription sur le site. L’adresse électronique
        (e-mail) de l’Utilisateur pourra notamment être utilisée par CITYLOG
        SARL pour la communication d’informations diverses et la gestion du
        compte. En France, les données personnelles sont notamment protégées par
        la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août 2004,
        l'article L. 226-13 du Code pénal et la Directive Européenne du 24
        octobre 1995. CITYLOG SARL ne collecte des informations personnelles
        (suivant l'article 4 loi n°78-17 du 06 janvier 1978) relatives à
        l'utilisateur que pour le besoin de certains services proposés par
        l’Editeur. L'Utilisateur fournit ces informations en toute connaissance
        de cause, notamment lorsqu'il procède par lui-même à leur saisie. Il est
        alors précisé à l'Utilisateur du site servicetransports.com, de ses
        sous-domaines et de ses services, l’obligation ou non de fournir ces
        informations. Conformément aux dispositions des articles 38 et suivants
        de la loi 78-17 du 6 janvier 1978 relative à l’informatique, aux
        fichiers et aux libertés, tout utilisateur dispose d’un droit d’accès,
        de rectification, de suppression et d’opposition aux données
        personnelles le concernant. Pour l’exercer, adressez votre demande à
        contact@servicetransports.com ou par écrit dûment signé, accompagné
        d’une copie du titre d’identité avec signature du titulaire de la pièce,
        en précisant l’adresse à laquelle la réponse doit être envoyée. Aucune
        information personnelle de l'Utilisateur du site servicetransports.com,
        de ses sous-domaines et de ses services, n'est publiée à l'insu de
        l'Utilisateur, échangée, transférée, cédée ou vendue sur un support
        quelconque à des tiers. Seule l'hypothèse du rachat de l’Editeur et de
        ses droits autorise CITYLOG SARL à transmettre lesdites informations à
        l'éventuel acquéreur qui serait à son tour tenu à la même obligation de
        conservation et de modification des données vis à vis de l'Utilisateur
        du site servicetransports.com, de ses sous-domaines, et de ses services.
        Le site servicetransports.com, ses sous-domaines et ses services, sont
        en conformité avec le RGPD voir notre politique RGPD.
        <br />
        <br />
        <b>ARTICLE 8 : Liens hypertextes</b>
        <br />
        <br />
        Les domaines vers lesquels mènent les liens hypertextes présents sur le
        site n’engagent pas la responsabilité de l’Éditeur de
        servicetransports.com et de ses sous-domaines, qui n’a pas de contrôle
        sur ces liens.
        <br />
        <br />
        <b>ARTICLE 9 : Évolution des conditions générales d’utilisation</b>
        <br />
        <br />
        Le site servicetransports.com et ses sous-domaines se réservent le droit
        de modifier les clauses de ces conditions générales d’utilisation à tout
        moment et sans justification.
        <br />
        <br />
        <b> ARTICLE 10 : Durée du contrat</b>
        <br />
        <br />
        La durée du présent contrat est indéterminée. Le contrat produit ses
        effets à l'égard de l'Utilisateur à compter du début de l’utilisation du
        service.
        <br />
        <b>ARTICLE 11 : Droit applicable et juridiction compétente</b>
        <br />
        <br />
        Le présent contrat dépend de la législation française. En cas de litige
        non résolu à l’amiable entre l’Utilisateur et l’Éditeur, les tribunaux
        de Créteil sont compétents pour régler le contentieux.
      </div>
    </Card>
  );
};

export default TermsOfUse;
